export const SECTION_KEYS = {
  networkOrdering: 'network-ordering',
};
